import { render, staticRenderFns } from "./TimeOffDetail.vue?vue&type=template&id=d87d0efc&scoped=true"
import script from "./TimeOffDetail.vue?vue&type=script&lang=js"
export * from "./TimeOffDetail.vue?vue&type=script&lang=js"
import style0 from "./TimeOffDetail.vue?vue&type=style&index=0&id=d87d0efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87d0efc",
  null
  
)

export default component.exports